import type { PartnerResponse } from "./schedule.service";
import { API_BASE_URL } from "./constants";
import { authenticatedFetch } from "@beholos/holoscommon";

export type PartnerTypeFilter =
  | 'showNutritionist'
  | 'showHealthCoach'
  | 'showPsychologist'
  | 'showFinancialAdvisor'
  | 'showPersonalTrainer'
  // legacy alias kept for backward compatibility
  | 'showFitnessCoach';

export const fetchPartnersOfType = async (
  filter?: PartnerTypeFilter,
  inPlan?: boolean
): Promise<PartnerResponse[]> => {
  try {
    let url = `${API_BASE_URL}/partners/type`;

    if (filter) {
      // Map legacy 'showFitnessCoach' to the correct API parameter
      const param = filter === 'showFitnessCoach' ? 'showPersonalTrainer' : filter;
      url += `?${param}=true`;
      if (inPlan) {
        url += `&inPlan=true`;
      }
    }

    console.log('Fetching partners of type from:', url);

    const response = await authenticatedFetch(url);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: PartnerResponse[] = await response.json();
    console.log('Partners Of Type API response:', data);

    return data;
  } catch (error) {
    console.error('Error fetching partners of type:', error);
    return [];
  }
};
